import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Real } from '../../../core/models/real.model';

@Component({
  selector: 'app-contact-us-modal',
  templateUrl: './contact-us-modal.component.html',
  styleUrls: ['./contact-us-modal.component.scss'],
})
export class ContactUsModalComponent implements OnInit {


  @Input() real: Real;

  limit: number;

  constructor(public modalCtrl: ModalController ) { }


  ngOnInit() {

    this.limit = this.real.contactUsPartySize ? this.real.contactUsPartySize : 50;

    /*if ( this.real.slug === 'restavracija-strelec' ) {
      this.limit = 12;
    }

    if ( this.real.slug === 'city-terasa-maribor' ) {
      this.limit = 30;
    }*/


  }

  onCancel() {
    this.modalCtrl.dismiss( 'close', 'cancel' );
  }


}
